import { render, staticRenderFns } from "./SharedRecordsAccessGate.vue?vue&type=template&id=b7cee7e2&scoped=true"
import script from "./SharedRecordsAccessGate.vue?vue&type=script&lang=js"
export * from "./SharedRecordsAccessGate.vue?vue&type=script&lang=js"
import style0 from "./SharedRecordsAccessGate.vue?vue&type=style&index=0&id=b7cee7e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cee7e2",
  null
  
)

export default component.exports